import { Action } from '@ngrx/store';
import { UserAgentInitState } from '../models/user-agent.interface';

export const UPDATE_USER_AGENT_DATA = 'UPDATE_USER_AGENT_DATA';
export const UPDATE_USER_AGENT_BOOKING_REFERENCE = 'UPDATE_USER_AGENT_BOOKING_REFERENCE';
export const RESET_USER_AGENT_DATA = 'RESET_USER_AGENT_DATA';

export interface ActionWithPayloadInterface extends Action {
  payload: any;
}

const initState: UserAgentInitState = {
  ip: null,
  userAgentString: null,
  appVersion: null,
  dateTimeLocal: null,
  bookingRef: null
};

export function userAgentReducer (state: UserAgentInitState = initState, action: ActionWithPayloadInterface) {

  switch (action.type) {
    case UPDATE_USER_AGENT_DATA:
      return Object.assign({}, action.payload);

    case UPDATE_USER_AGENT_BOOKING_REFERENCE:
      return Object.assign({}, state, { bookingRef: action.payload });

      case RESET_USER_AGENT_DATA:
        return Object.assign({}, initState);

    default:
      return state;

  }
};
